// WeighbridgeLayout — pushes <WeighbridgeNav /> into the SidebarContext for
// the Weighbridge Management module's route subtree, then wraps the outlet
// in the module-level context providers.
//
// Same nav-injection pattern as SkipLayout / CollectionsLayout. The two
// provider scaffolds (WbCompanySettingsProvider, WbTicketProvider) are
// no-ops in C1 — they exist so later phases can fill them without
// re-wrapping every route. SubscriptionGate is applied here so a tenant
// without the weighbridge tier sees a single locked screen instead of one
// per route.

import { Outlet } from 'react-router-dom';
import { useSidebarContent } from '../../components/shell/SidebarContext';
import { SubscriptionGate } from '../../components/SubscriptionGate/SubscriptionGate';
import { WeighbridgeNav } from './components/WeighbridgeNav';
import { WbCompanySettingsProvider } from './context/WbCompanySettingsContext';
import { WbLiveWeightProvider } from './context/WbLiveWeightContext';
import { WbTicketProvider } from './context/WbTicketContext';

const WEIGHBRIDGE_NAV = <WeighbridgeNav />;

export function WeighbridgeLayout() {
  useSidebarContent(WEIGHBRIDGE_NAV);
  return (
    <SubscriptionGate feature="weighbridge">
      <WbCompanySettingsProvider>
        <WbLiveWeightProvider>
          <WbTicketProvider>
            <Outlet />
          </WbTicketProvider>
        </WbLiveWeightProvider>
      </WbCompanySettingsProvider>
    </SubscriptionGate>
  );
}
